import "./assests/css/fonts/fontStyle.css";
import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import ScrollToTop from './components/Customer/ScrollToTop/ScrollToTop';

/* ================= USER SCREENS ================= */
import Home from './screen/user/Home/Home';
import Women from './screen/user/women/Women';
import MenPage from './screen/user/men/MenPage';
import Kidspage from './screen/user/kids/Kidspage';
import ShoppingCartPage from './screen/user/ShoppingCartPage/ShoppingCartPage';
import ProductDetailPage from './screen/user/ProductDetailPage/ProductDetailPage';
import Customize from './screen/user/Customize/Customize';
import Accessories from './screen/user/Accessories/Accessories';
import BlogPage from './screen/user/Blogpage/Blog';
import BlogDetail from './screen/user/Blogpage/BlogdetailPage';
import AboutUs from './screen/user/About-Us/AboutUs';
import ContactUs from './screen/user/ContactUs/ContactUs';


/* ================= STATIC PAGES ================= */
import Terms from './components/Customer/Footer/pages/Terms';
import Privacy from './components/Customer/Footer/pages/Privacy';
import Security from './components/Customer/Footer/pages/Security';
import Cookies from './components/Customer/Footer/pages/Cookies';
import Payments from './components/Customer/Footer/pages/Payments';

/* ================= ADMIN ================= */
import MyNavbar from './components/Customer/Mynavbar/MyNavbar';
import AdminLogin from './screen/admin/AdminPanel/AdminLogin/AdminLogin';
import AdminMasterLayout from './Layouts/AdminMasterLayout/AdminMasterLayout';
import Dashboard from './screen/admin/AdminPanel/Dashboard/Dashboard';
import ProductManagement from './screen/admin/AdminPanel/ProductManagement/ProductManagement';
import CustomerManagement from './screen/admin/AdminPanel/CustomerManagement/CustomerManagement';
import HelpSupport from './screen/admin/AdminPanel/HelpSupport/HelpSupport';
import AdminAnalytics from './screen/admin/AdminPanel/AdminAnalytics/AdminAnalytics';
import AdminAttributes from './components/Admin/AdminAttributes/AdminAttributes';
import Invoices from './components/Admin/Invoices';
import PaymentCustomer from './components/Admin/PaymentCustomer/PaymentCustomer';
import BlogManagement from './screen/admin/AdminPanel/BlogMangement/BlogMangement';
import Settings from './components/Admin/Settings';
// import Subscribers from './screen/admin/AdminPanel/Subscribers/Subscribers';
import AdminInventory from './screen/admin/AdminPanel/Inventory/Inventory';
import AdminStoreSetting from './screen/admin/AdminPanel/AdminStoreSetting/AdminStoreSetting';
import Conversation from './screen/admin/AdminPanel/Conversation/Conversation';
import AdminProfileSetting from './screen/admin/AdminPanel/AdminProfileSetting/AdminProfileSetting';
import AdminNotification from './screen/admin/AdminPanel/AdminNotification/AdminNotification';
import DisputeManagement from './screen/admin/AdminPanel/DisputeManagement/DisputeManagement';
import SubAdminManagement from './screen/admin/AdminPanel/SubAdminManagement/SubAdminManagement';
import Feedback from './screen/admin/AdminPanel/Feedback/Feedback';

/* ================= CUSTOMER DASHBOARD ================= */
import UserProfile from './subscreens/User/UserProfile/UserProfile';
import Orders from './subscreens/User/Orders/Orders';
import UserNotification from './subscreens/User/Notification/UserNotification';
import UserAccountSetting from './subscreens/User/UserAcountSetting/UserAccountSetting';
import UserAddress from './subscreens/Address/UserAddress';
import UserPayments from './subscreens/User/UserPayments/UserPayments';
import Dispute from './subscreens/User/Dispute/Dispute';
 import OrderSuccess from './subscreens/User/OrderSuccess/OrderSuccess';

/* ================= OTHER COMPONENTS ================= */
import NotificationStyles from './components/Customer/notfication/NotificationStyles';
import UploadScreen from './components/Customer/UploadScreen/UploadScreen';



import Customization from './subscreens/Women/SubScreens/Customization/Customization';
import SalePageForCustomer from './subscreens/Home/SalePageForCustomer/SalePageForCustomer';
import AiFeature from './components/Admin/Dasboard/AiFeature/AiFeature';
import Customerlogin from './screen/user/CustomerLogin/Customerlogin';
import WishlistPage from './screen/user/WishlistPage/WishlistPage';
import ContactForm from './screen/user/Home/ContactForm/ContactForm';
import AdminContactForm from './screen/admin/AdminPanel/AdminContactForm/AdminContactForm';
import SaleManagement2 from './screen/admin/AdminPanel/SaleManagement2/SaleManagement2';
import CheckoutPage from "./screen/user/CheckoutPage/CheckoutPage";
import NotFound from "./screen/NotFound/NotFound";
import OrdersPage from "./screen/admin/AdminPanel/OrdersPage/OrdersPage";
import AdminCategory from "./components/Admin/AdminCategory";
import CategoryCircles from "./components/Customer/CategoryCircles/CategoryCircles";
import Carousel from "./screen/user/Home/subscreens/Carousel/Carousel";
import WomenPage from "./screen/user/women/Women";
import OrderResultPage from "./screen/user/OrderResultPage/OrderResultPage";
import CustomerFeedback from "./screen/user/CustomerFeedback/CustomerFeedback";
import TestimonialsSection from "./screen/user/Home/subscreens/TestimonialsSection/TestimonialsSection";

import SaleProductsPage from './screen/user/SaleProductPage/SaleProductsPage';
import CustomizationOptionsModal from "./components/Admin/CustomizationOptionsModal";
import ProductsPage from "./screen/user/products/ProductsPage";

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      <ScrollToTop />

      {!isAdminRoute && <MyNavbar />}
      {/* {!isAdminRoute && <ChatBot />} */}

      <Routes>
        {/* Customer ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/sale-page" element={<SalePageForCustomer />} />
        <Route path="/sale-products" element={<SaleProductsPage />} />
        {/* <Route path="/category/:categoryId" element={<Women />} /> */}
        <Route path="/carousel" element={<Carousel />} />
        <Route path="/category" element={<CategoryCircles />} />
        <Route path="/women" element={<WomenPage />} />

        <Route path="/men" element={<MenPage />} />
        <Route path="/products/:categoryname" element={<ProductsPage />} />
     <Route path="/products/:categoryname" element={<Kidspage />} />
        <Route path="/accessries" element={<Accessories />} />







        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/cart" element={<ShoppingCartPage />} />
        <Route path="/product-detail/:productId" element={<ProductDetailPage />} />
        
        <Route path="/customize" element={<Customize />} />
        <Route path="/login" element={<Customerlogin />} />

        {/* <Route path="/signup" element={<Signup />} /> */}
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog-detail/:id" element={<BlogDetail />} />
        <Route path="/customization" element={<Customization />} />
        <Route path="/try-on" element={<UploadScreen />} />
        {/* <Route path="/result" element={<ResultScreen />} /> */}
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/customer/feedback" element={<CustomerFeedback />} />
        <Route path="/customer/test" element={<TestimonialsSection />} />



        {/* STATIC PAGES */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/security" element={<Security />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/payments" element={<Payments />} />

        <Route path="/dress-customize" element={<Customization />} />
        <Route path="upload" element={<UploadScreen />} />
        <Route path="/notifications" element={<NotificationStyles />} />

        {/* USER DASHBOARD */}
        <Route path="/user" element={<OrderSuccess />} />
        <Route path="/customer/profile" element={<UserProfile />} />
        <Route path="/customer/order" element={<Orders />} />
        <Route path="/customer/address" element={<UserAddress />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/customer/notification" element={<UserNotification />} />
        <Route path="/customer/helpsupport" element={<Dispute />} />
        <Route path="/customer/setting" element={<UserAccountSetting />} />
        <Route path="/user/payment" element={<UserPayments />} />
        <Route
  path="/success"
  element={<OrderResultPage type="success" />}
/>

<Route
  path="/cancel"
  element={<OrderResultPage type="cancel" />}
/>
                 {/* <Route path="/user/dispute" element={<Dispute />} /> */}
        {/* <Route path="/user/reviews" element={<Review />} /> */}

        {/* ADMIN AUTH */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* ADMIN PANEL */}
        <Route path="/admin" element={<AdminMasterLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="categories" element={<AdminCategory />} />
          <Route path="product-management" element={<ProductManagement />} />
          <Route path="inventory" element={<AdminInventory />} />
          <Route path="attributes" element={<AdminAttributes />} />
          <Route path="customer-management" element={<CustomerManagement />} />
          <Route path="customers" element={<CustomerManagement />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="payments" element={<PaymentCustomer />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="analytics" element={<AdminAnalytics />} />
          <Route path="feedback" element={<Feedback />} />
          <Route path="sales" element={<SaleManagement2 />} />
          <Route path="store-setting" element={<AdminStoreSetting />} />
          <Route path="help-support" element={<HelpSupport />} />
          <Route path="AI-Features" element={<AiFeature />} />
          <Route path="contact-forms" element={<AdminContactForm />} />
          <Route path="chat" element={<Conversation />} />
          <Route path="notifications" element={<AdminNotification />} />
          <Route path="settings" element={<Settings />} />
          {/* <Route path="subscribers" element={<Subscribers />} /> */}
          <Route path="blogs" element={<BlogManagement />} />
          <Route path="disputes" element={<DisputeManagement />} />
          <Route path="subadmin" element={<SubAdminManagement />} />
<Route path="/admin/CustomizationOptionsModal" element={<CustomizationOptionsModal />} />
        </Route>
        <Route path="/Admin-profile-setting" element={<AdminProfileSetting />} />

      </Routes>
    </>
  );
}

export default App;